import React from "react";
import {
    Box,
    Typography,
    Button,
    Dialog,
    DialogContent,
    IconButton,
    useTheme,
} from "@mui/material";
import AndroidIcon from "@mui/icons-material/Android";
import CloseIcon from "@mui/icons-material/Close";

const DownloadAppModal = ({ open, onClose }) => {
    const theme = useTheme();

    return (
        <Dialog open={open} onClose={onClose} maxWidth="xs" fullWidth>
            <DialogContent
                sx={{
                    position: "relative",
                    py: { xs: 4, sm: 5 },
                    px: { xs: 2, sm: 3 },
                    textAlign: "center",
                    display: "flex",
                    flexDirection: "column",
                    alignItems: "center",
                    bgcolor: theme.palette.background.paper,
                }}
            >
                {/* Close */}
                <IconButton
                    onClick={onClose}
                    sx={{
                        position: "absolute",
                        top: 8,
                        right: 8,
                        color: theme.palette.text.secondary,
                    }}
                >
                    <CloseIcon />
                </IconButton>



                <Typography
                    sx={{
                        mb: 2,
                        fontSize: 22,
                        fontWeight: 600,
                        color: theme.palette.text.primary,
                        letterSpacing: 0.5,
                    }}
                >
                    Arth
                    <span style={{ color: theme.palette.primary.main }}>Gyan</span>
                </Typography>


                {/* QR */}
                <Box
                    component="img"
                    src="https://ik.imagekit.io/arthgyan/Arthgyan_Web/App%20qrCode?updatedAt=1761222156553"
                    alt="QR Code"
                    sx={{
                        width: { xs: 220, sm: 300 },
                        height: { xs: 220, sm: 300 },
                        mb: 3,
                    }}
                />

                {/* Play Store Button */}
                <Button
                    variant="contained"
                    startIcon={<AndroidIcon />}
                    href="https://play.google.com/store/apps/details?id=com.arthgyan.financemanager"
                    target="_blank"
                    sx={{
                        px: 3,
                        py: 1,
                        borderRadius: "8px",
                        fontWeight: 600,
                        backgroundColor: "#0080a7",

                        color: "#fff",
                        textTransform: "none",
                        boxShadow: `0 6px 18px ${theme.palette.primary.main}55`,
                        "&:hover": {
                            backgroundColor: theme.palette.primary.dark,
                        },
                    }}
                >
                    Get on Play Store
                </Button>
            </DialogContent>
        </Dialog>
    );
};

export default DownloadAppModal;
